import React, { useState } from "react";
import DashboardLayout from "../../../Layout/DashboardLayout";
import SearchBox from "./SearchBox";
import { useGetDiscountsQuery } from "../../../hooks/DiscountManagement/useGetDiscountsQuery";
import { Table } from "antd";
import { formatNumberWithCommas } from "../../../utils/formatNumber";
import Moment from "react-moment";
import { useNavigate } from "react-router-dom";
import KoboConverter from "Components/KoboConverter";

const DiscountManagement = () => {
  const [search, setSearch] = useState("");
  const { data: discounts, isPending: isPendingDiscounts } =
    useGetDiscountsQuery({});
  const navigate = useNavigate();

  const columns = [
    {
      title: "Discount Name",
      dataIndex: "discountName",
      key: "discountName",
    },
    {
      title: "Type",
      dataIndex: "discountType",
      key: "discountType",
      render: (discountType: string | null) => (
        <span className="">{discountType ? discountType : "N/A"}</span>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (description: string | null) => (
        <span className="">{description ? description : "N/A"}</span>
      ),
    },
    {
      title: "Discount",
      dataIndex: "percentageOff",
      key: "percentageOff",
      render: (percentageOff: string | null) => (
        <span className="">
          {percentageOff ? percentageOff + "%" : "Never"}
        </span>
      ),
    },
    {
      title: "Min. Order Amount",
      dataIndex: "minimumOrderAmount",
      key: "minimumOrderAmount",
      render: (minimumOrderAmount: string | number | null) => (
        <span>
          {minimumOrderAmount ? (
            <KoboConverter amount={minimumOrderAmount} />
          ) : (
            "N/A"
          )}
        </span>
      ),
    },
    {
      title: "Max Discount Amount",
      dataIndex: "maxDiscountAmount",
      key: "maxDiscountAmount",
      render: (maxDiscountAmount: string | number | null) => (
        <span>
          {maxDiscountAmount ? (
            <KoboConverter amount={maxDiscountAmount} />
          ) : (
            "N/A"
          )}
        </span>
      ),
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt: string | null) => (
        <span className="">
          {createdAt ? (
            <Moment interval={0} format="DD-MM-YYYY">
              {createdAt}
            </Moment>
          ) : (
            "N/A"
          )}
        </span>
      ),
    },
    {
      title: "Discount Code",
      dataIndex: "discountCode",
      key: "discountCode",
      render: (discountCode: string | null) => (
        <span className="font-bold">{discountCode ? discountCode : "N/A"}</span>
      ),
    },
  ];

  return (
    <DashboardLayout
      title="Discount Management"
      right={<SearchBox search={search} setSearch={setSearch} />}
    >
      <div className="px-[30px] mt-5">
        <div className="flex flex-col h-full">
          <Table
            dataSource={discounts && discounts.data.docs}
            columns={columns}
            scroll={{ y: "calc(100vh - 200px)" }}
            rowKey="id"
            className=""
            loading={isPendingDiscounts}
            onRow={(record: any) => ({
              onClick: () => navigate(`/discount-management/${record.id}`),
            })}
          />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default DiscountManagement;
